
import React, { useState, useEffect } from 'react';
import {
    TextField, Button, InputLabel, MenuItem, FormControl, Select, Box, FormHelperText, Autocomplete
} from '@mui/material';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProducts, validateShipmentLotExistence, fetchUOM } from '../../../redux/shipmentSlice.js';
import ViewShipment from "./ViewShipment";
import { ACTION } from '../../../helpers/commonName.js';
import AddLotForProductWarningModal from '../../../components/Modals/AddLotForProductWarningModal.js';

const nonEngChar = /[^-A-Za-z0-9_@,.:;{}/&%()'"#*<>!$?+\n ]/;
const productSchema = yup.object({
    productName: yup.string().required('Product is required'),
    productQty: yup.number().required('Quantity is required').positive().integer(),
    productUom: yup.string().required('Unit is required'),
    productDescription: yup.string().max(300, 'Product description should not exceed 100 characters')
    .test('non-eng-char', 'Please enter English characters only.', (value) => !nonEngChar.test(value)),
    blendPercentage: yup.number().required('Blend percentage is required').positive().max(100).min(1),
    shipmentProductLotNo: yup.string().max(100, 'Finished goods Lot Number should not exceed 100 characters')
    .test('non-eng-char', 'Please enter English characters only.', (value) => !nonEngChar.test(value)),
});

const AddProductForm = ({ onSubmit, isLinked, shipmentId, selectedProductId, actionType, productCount, handlePrevious, handleNext, currentStep }) => {
    const dispatch = useDispatch()
  
    const shipmentProducts = useSelector(state =>
        state.shipment.shipmentDetails && state.shipment.shipmentDetails.data
            ? state.shipment.shipmentDetails.data.shipmentProducts
            : []);
    productCount=shipmentProducts.length;
    // console.log("shipmentProductsshipmentProducts",shipmentProducts)
    // console.log("shipmentProducts in addproduct", shipmentProducts);

    const [message, setMessage] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const initialValues = shipmentProducts?.find(product => product.shipmentProductId === selectedProductId)

    const defaultValues = {
        productDescription: '',
        productQty: '',
        productUom: '',
        blendPercentage: '',
        shipmentProductLotNo: '',
        productId: ''
    };

    // const product = {
    //     productName: initialValues?.productName || '',
    //     productUom: initialValues?.productUom || '',
    //     productQty: initialValues?.productQty || '',
    //     productDescription: initialValues?.productDescription || '',
    //     shipmentProductLotNo: initialValues?.shipmentProductLotNo || '',
    //     blendPercentage: initialValues?.blendPercentage || '',
    // }

    const product = actionType === ACTION.EDIT ? {
        productName: initialValues?.productName || '',
        productUom: initialValues?.productUom || '',
        productQty: initialValues?.productQty || '',
        productDescription: initialValues?.productDescription || '',
        shipmentProductLotNo: initialValues?.shipmentProductLotNo || '',
        blendPercentage: initialValues?.blendPercentage || '',
        productId: initialValues?.productId || '',
    } : defaultValues;

    // console.log("product", product,"actuil",actionType);

    // const productList = useSelector(state => state.products|| []);
    const productList = useSelector((state) => state.shipment.productList || []);
    const unitOptions = useSelector((state) => state.shipment.uom?.data || []);
  
    // Map the data to the format required by the autocomplete component
    // console.log("productList",productList)
    const productsOptions = productList.map(product => ({
        label: product.productName,
        value: product.productId
    }));

    const handleNextClick = async () => {
        const response = await validateShipmentLotExistence(shipmentId, 'checkLotExists');
        // console.log("response",response);
        if (response === 0) {
            setMessage("Please Add Lot to proceed");
            setIsModalOpen(true)
        } else if (response === -1) {
            setMessage("Are you sure you don't want to add lot for all products? Please delete those products for which you don't want to add lot.");
            setIsModalOpen(true)
        } else {
            handleNext()
        }
    }

    const onModalClose = () => {
        setIsModalOpen(false);
    }

    const resetForm = (obj) => {
        // console.log("inside reset function!!", obj)
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                obj[key] = defaultValues[key];
            }
        }
    }

    useEffect(() => {
        const queryParams = {
            type: 'shipment'
        };
        dispatch(fetchProducts(queryParams));
    }, [dispatch]);

    useEffect(() => {
        const queryParams = {
            type: 'SHP'
        };
        dispatch(fetchUOM(queryParams));
    }, [dispatch])

    return (
        <>
            <Formik
                // initialValues={initialValues}
                initialValues={product}
                enableReinitialize
                validationSchema={productSchema}
                onSubmit={(values, { setSubmitting }) => {
                    const formattedValues = {
                        ...values,
                        // orderDate: dayjs(values.orderDate).format('YYYY-MM-DD'),
                        // orderExpectedDate: dayjs(values.orderExpectedDate).format('YYYY-MM-DD'),
                    };
                    // console.log('Formatted Submit:', formattedValues);
                    onSubmit(formattedValues);
                    setSubmitting(false);
                    // if(isNext === true){
                    // } else
                    if (actionType === ACTION.ADD) {
                        resetForm(values); // Optionally reset the form only on add action
                    } else if (actionType === ACTION.EDIT) {
                        // handleNext()
                    }

                }}
            >
                {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
                    <form onSubmit={handleSubmit}>
                        {/* <Box sx={{ display: 'flex', gap: 2 }}> */}
                        <div className="row">
                            <div className="col-md-12 cs-form mb-3">
                                <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    className='md-input'
                                    options={productsOptions}
                                    getOptionLabel={(option) => option.label || ''}
                                    value={productsOptions.find(option => option.label === values.productName) || null}
                                    onChange={(event, newValue) => {
                                        // setProducts('productName', newValue ? newValue.label : '');
                                        handleChange({ target: { name: 'productName', value: newValue?.label || '' } });
                                        handleChange({ target: { name: 'productId', value: newValue?.value } });
                                    }}
                                    onBlur={handleBlur}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Product"
                                            name="productName"
                                            error={touched.productName && Boolean(errors.productName)}
                                            helperText={touched.productName && errors.productName}
                                        />
                                    )}
                                />
                            </div>

                        </div>
                        {/* </Box> */}
                        <div className="row">
                            <div className="col-md-3 cs-form mb-2">
                                <TextField
                                    name="shipmentProductLotNo"
                                    label="Finished goods lot number"
                                    className='md-input'
                                    value={values.shipmentProductLotNo}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={touched.shipmentProductLotNo && Boolean(errors.shipmentProductLotNo)}
                                    helperText={touched.shipmentProductLotNo && errors.shipmentProductLotNo}
                                />
                            </div>
                            <div className="col-md-3 cs-form mb-2">
                                <TextField
                                    name="productQty"
                                    label="Quantity *"
                                    className='md-input'
                                    type="number"
                                    value={values.productQty}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={touched.productQty && Boolean(errors.productQty)}
                                    helperText={touched.productQty && errors.productQty}
                                    inputProps={{ min: "0" }}
                                />
                            </div>
                            <div className="col-md-3 cs-form mb-2">

                                <FormControl className='md-input'
                                >
                                    <InputLabel id="unit-label">Unit *</InputLabel>
                                    <Select
                                        labelId="unit-label"
                                        name="productUom"
                                        value={values.productUom}
                                        label="Unit *"
                                        onChange={handleChange}
                                        error={touched.productUom && Boolean(errors.productUom)}
                                    >
                                        {unitOptions.map((option) => (
                                            <MenuItem key={option.uom_id} value={option.uom}>
                                                {option.uom}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    <FormHelperText>{touched.productUom && errors.productUom}</FormHelperText>
                                </FormControl>
                            </div>
                            <div className="col-md-3 cs-form mb-2">
                                <TextField
                                    name="blendPercentage"
                                    label="Blend % of Birla Cellulose *"
                                    className='md-input'
                                    type="number"
                                    value={values.blendPercentage}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={touched.blendPercentage && Boolean(errors.blendPercentage)}
                                    helperText={touched.blendPercentage && errors.blendPercentage}
                                />
                            </div>
                            {/* </Box> */}
                        </div>
                        <div className='row'>
                            <div className="col-md-12 cs-form mb-6">
                                <TextField
                                    name="productDescription"
                                    className='md-input'
                                    label="Product Description"
                                    multiline
                                    rows={4}
                                    value={values.productDescription}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={touched.productDescription && Boolean(errors.productDescription)}
                                    helperText={touched.productDescription && errors.productDescription}
                                    inputProps={{
                                        maxLength: 300,
                                    }}
                                // helperText={`${values.productDescription.length}/300`}
                                />
                            </div>
                        </div>
                        <div class="input-group mb-3">
                            <div className="col-md-12 cs-form mb-6 mt-3">

                            </div>
                        </div>
                        {
                            currentStep === 2 ?
                                <div className="d-flex justify-content-between mt-3">
                                    <button type="button" className="btn btn-light grey-btn lg-btn" onClick={handlePrevious}>Previous</button>
                                    <div>
                                        <button type="submit" className="btn btn-primary greeen-btn lg-btn me-3" onClick={handleSubmit}>
                                            {actionType === ACTION.ADD ? 'Add Product' : 'Save Changes'}
                                        </button>
                                        {actionType !== ACTION.EDIT ?
                                            <button
                                                className="btn btn-primary greeen-btn lg-btn"
                                                type='button'
                                                variant="contained"
                                                onClick={handleNextClick} // Use onClick to trigger form submission
                                                disabled={!productCount}
                                            >
                                                Next
                                            </button>
                                            : <></>
                                        }
                                    </div>
                                </div>
                                :
                                <></>
                        }

                        {/* ... other input fields */}
                    </form>)

                }
            </Formik >
            {message &&
                <AddLotForProductWarningModal isOpen={isModalOpen} onClose={onModalClose} message={message} />}
        </>
    )
}
export default AddProductForm